import { createContext } from 'react';

export interface TableContextProps {
  stickyHeader?: boolean;
}

export const TableContext = createContext<TableContextProps>({});

if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'LumaTableContext';
}
